<template>
  <div class="position-relative" style="z-index: 1030">
    <div class="row no-gutters justify-content-center">
      <div class="fixed-bottom d-block nav-bottom" style="bottom:0%">
        <div class="custom-container-fluid px-0">
          <div class="row justify-content-center no-gutters">
            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
              <div class="bg-white">
                <div class="w-100 py-2" style="box-shadow: rgb(236 236 236 / 48%) 0px -2px 3px;">
                  <div class="row no-gutters">
                    <div class="text-center" :class="col_class">
                      <router-link :to="'/'+getMerchant().code+'/concierge'">
                        <img src="../../assets/img/icon/menu/icn_home.png" v-if="HomeMenu" width="18" />
                        <img src="../../assets/img/icon/menu/icn_home_inactive.png" v-else width="18" />
                        <p class="mb-0 overline pt-1" :class="{'text-green':HomeMenu}">{{$t('general.home')}}</p>
                      </router-link>
                    </div>
                    <div class="text-center position-relative" :class="col_class">
                      <!-- <div class="bg-green text-center rounded-100 w-16px position-absolute m-auto left__menu" style="padding: 1px;">
                        <p class="mb-0 text-10 body-2-2 font-bold text-white position-relative" style="left: 0.5px">1</p>
                      </div> -->
                      <router-link :event="getConciergeReservation().status != 'SUBMIT_FORM' ? 'click' : ''" :class="{'cursor-disable': getConciergeReservation().status == 'SUBMIT_FORM'}" :to="'/'+getMerchant().code+'/concierge/order'">
                        <img src="../../assets/img/icon/concierge/shopping-bag-green.svg" v-if="OrderMenu" width="22" />
                        <img src="../../assets/img/icon/concierge/shopping-bag.svg" v-else width="22" />
                        <p class="mb-0 overline pt-1" :class="{'text-green':OrderMenu}">{{$t('general.order')}}</p>
                      </router-link>
                    </div>
                    <div v-if="getMerchant().use_membership" class="text-center" :class="col_class">
                      <router-link :event="getConciergeReservation().status != 'SUBMIT_FORM' ? 'click' : ''" :class="{'cursor-disable': getConciergeReservation().status == 'SUBMIT_FORM'}" :to="'/'+getMerchant().code+'/concierge/member'">
                        <img src="../../assets/img/icon/menu/giftbox.svg" v-if="RewardMenu" width="18" />
                        <img src="../../assets/img/icon/menu/giftbox-inactive.svg" v-else width="18" />
                        <p class="mb-0 overline pt-1" :class="{'text-green':RewardMenu}">{{$t('hotel.concierge.reward')}}</p>
                      </router-link>
                    </div>
                    <!-- <div class="col-3 text-center">
                      <router-link :to="'/'+getMerchant().code+'/concierge/chat'">
                        <img src="../../assets/img/hotel/speech-bubble.png" width="18">
                        <p class="body-2-2 text-12 mb-0 mt-1" style="color: #c1c1c1">Chat</p>
                      </router-link>
                    </div> -->
                    <div class="text-center" :class="col_class">
                      <router-link :event="getConciergeReservation().status != 'SUBMIT_FORM' ? 'click' : ''" :class="{'cursor-disable': getConciergeReservation().status == 'SUBMIT_FORM'}" :to="'/'+getMerchant().code+'/concierge/account'">
                        <img src="../../assets/img/icon/menu/icn_profile.png" v-if="ProfileMenu" width="18" />
                        <img src="../../assets/img/icon/menu/icn_profile_inactive.png" v-else width="18" />
                        <p class="mb-0 overline pt-1" :class="{'text-green':ProfileMenu}">{{$t('general.account')}}</p>
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {mapGetters} from "vuex";
  
  export default{
    data(){
      return{

      }
    },
    methods: {
      ...mapGetters(['getMerchant','getConciergeReservation']),
    },
    computed: {
      col_class(){
        return this.getMerchant().use_membership ? 'col-3' : 'col-4'
      },
      HomeMenu(){
        let data = false
        if (this.$route.name == 'ConciergeMainPage') {
          data = true
        }
        return data 
      },
      OrderMenu(){
        let data = false
        if(this.$route.name == 'ConciergeOrder'){
          data = true
        }
        return data
      },
      RewardMenu(){
        let data = false
        if(this.$route.name == 'ConciergeMember'){
          data = true
        }
        return data
      },
      ProfileMenu(){
        let data = false
        if (this.$route.name == 'ConciergeAccount') {
          data = true
        }
        return data
      }
    }
  }
</script>

<style scoped>
  .left__menu{
    left: 60px;
  }

  @media screen and (max-width: 655px) {
    .left__menu{
      left: 48px;
    }
  }  
</style>


// WEBPACK FOOTER //
// src/components/hotel/BottomNavbar.vue